import React, { useEffect, useState } from "react";
import { Button, Popconfirm } from "antd";
import {CloseOutlined, DownloadOutlined, FacebookFilled} from "@ant-design/icons";
import {Download} from "lucide-react";
import { toast } from 'sonner'

export default ({ data, loading, buttonLoading, uninstall, install }) => {
    const [logging, setLogging] = useState(false);
    const [unavailable, setUnavailable] = useState(false);
    const [requestData, setRequestData] = useState({});

    const onLoginClick = () => {
        setLogging(true);
        try {
            window.FB.login(function (response) {
                if (response.authResponse) {
                    const authResponse = response.authResponse;
                    setRequestData((old) => ({ ...old, ...authResponse }))
                    toast.success("Login realizado com sucesso!");
                } else {
                    toast.info("Operação cancelada pelo usuário");
                }
                setLogging(false);
            }, {
                scope: 'public_profile,email,ads_read,business_management',
                return_scopes: true
            });
        } catch (e) {
            console.error(e)
            toast.error("Falha ao realizar operação");
            setLogging(false);
        }
    };

    useEffect(() => {
        window.fbAsyncInit = () => {
            window.FB.init({
                appId: '370681945902930', // Using the same App ID as seen in fb-login
                autoLogAppEvents: true,
                xfbml: true,
                version: 'v20.0'
            });
        };
        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    }, []);

    useEffect(() => {
        const { accessToken, userID } = requestData;
        if (!accessToken || !userID)
            return;

        install({ accessToken, userID, ...requestData })
        setRequestData({});
    }, [requestData]);

    if (data) return (
        <div>
            <Popconfirm title={'Tem certeza?'}
                onConfirm={uninstall}
                description={'Essa ação é irreversível. (Você ainda poderá instalar novamente)'}>
                <Button type={'default'}
                    loading={loading || buttonLoading}
                    danger
                    icon={<CloseOutlined />}
                >{loading ? undefined : 'Remover'}</Button>
            </Popconfirm>
        </div>
    )

    return (
        <div>
            <Button type={'primary'}
                loading={loading || buttonLoading || logging}
                onClick={onLoginClick}
                disabled={unavailable}
                icon={<DownloadOutlined />}
            >{loading ? undefined : logging ? 'Logando...' : unavailable ? 'Indisponível' : 'Instalar'}</Button>
        </div>
    );
};
